import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';
import QuantumPurchase from './QuantumPurchase';
import './CreditPurchase.css';

const CreditPurchase = () => {
  const { user } = useContext(AuthContext);
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/packages`
      );
      
      if (data.success) {
        setPackages(data.data);
      } else {
        setError('Failed to load packages');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handlePurchase = (pkg) => {
    setSelectedPackage(pkg);
    setShowPurchaseModal(true);
  };

  const handlePurchaseSuccess = (result) => {
    setShowPurchaseModal(false);
    // Show success message or confetti
    alert(`Purchase successful! ${result.creditsAdded} credits added to your account.`);
  };

  if (loading) {
    return <div className="loading">Loading packages...</div>;
  }

  return (
    <div className="credit-purchase-container">
      <h2>Buy Credits</h2>
      <p className="current-credits">
        Your current balance: <strong>{user.credits} credits</strong>
      </p>
      
      {error && <div className="error-message">{error}</div>}
      
      <div className="packages-grid">
        {packages.map(pkg => (
          <div key={pkg._id} className={`package-card ${pkg.popular ? 'popular' : ''}`}>
            {pkg.popular && <div className="popular-badge">Most Popular</div>}
            
            <h3>{pkg.name}</h3>
            <div className="credits-amount">{pkg.credits} credits</div>
            
            <div className="price">
              ${pkg.price}
              {pkg.discount > 0 && (
                <span className="discount">Save {pkg.discount}%</span>
              )}
            </div>
            
            <p className="package-description">{pkg.description}</p>
            
            <button 
              className="purchase-btn"
              onClick={() => handlePurchase(pkg)}
            >
              Buy Now
            </button>
          </div>
        ))}
      </div>
      
// And update the QuantumPurchase component usage:
{showPurchaseModal && selectedPackage && (
  <QuantumPurchase
    creditPackage={selectedPackage}  // Changed from package to creditPackage
    onSuccess={handlePurchaseSuccess}
    onClose={() => setShowPurchaseModal(false)}
  />
)}
    </div>
  );
};

export default CreditPurchase;